import { render, staticRenderFns } from "./ManageNewsContentCard.vue?vue&type=template&id=465f0e4a"
import script from "./ManageNewsContentCard.vue?vue&type=script&lang=js"
export * from "./ManageNewsContentCard.vue?vue&type=script&lang=js"
import style0 from "./ManageNewsContentCard.vue?vue&type=style&index=0&id=465f0e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports